import DashboardSearch from "@components/DashboardSearch"
import LoggedInUser from "@components/LoggedInUser"
import PageContext from "@contexts/pageContext"
import MainNavigation from '@sections/Admin/components/MainNavigation'
import { MainContent, ModalContext, TopBar } from "@domain-group/suit-theme"
import PageContent from "./components/PageContent"
import { useModals } from "@domain-group/react-hooks"
import useMainNavigation from "@hooks/useMainNavigation"

const FieldMapping = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()
  const modalContext = useModals()

  return (
    <PageContext.Provider value={{}}>
      <ModalContext.Provider value={modalContext}>
        <TopBar
          callbacks={{ toggleNavigation }}
          loggedInUserComponent={<LoggedInUser />}
          searchComponent={<DashboardSearch searchEntities={['LayoutTemplate', 'TaskList', 'TemplatePage', 'TemplatePagePartial']} />}
        />

        <MainNavigation />

        <MainContent offset={{ top: TopBar.topBarHeight }}>
          <PageContent />
        </MainContent>

      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default FieldMapping
